export default defineNuxtPlugin((nuxtApp) => {
    const { session } = useUserSession()

    const config = useRuntimeConfig()

    const headers = useRequestHeaders()

    const api = $fetch.create({
        baseURL: `/api`,
        headers,
        onRequest({ request, options, error }) {

        },
        async onResponseError({ response }) {
            if (response.status === 401) {
                await nuxtApp.runWithContext(() => navigateTo('/login'))
            }
        },
    })

    // Expose to useNuxtApp().$api
    return {
        provide: {
            api,
        },
    }
})